// export const API_PATH = "http://130.61.25.58";
// export const API_PATH = "http://localhost:9091";
export const API_PATH = "https://ercetin.bisoft.com.tr";